import Class from './c-actual-tab';
import './c-actual-tab@';

export default Class;